module.exports = {"verification.modal.content.text":"Se ha enviado una verificación a tu email. Para completar la activación, haz clic en el enlace de verificación en el email, y luego regresa a esta página e intenta nuevamente.","verification.modal.content.status":"Esperando verificación del email"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/components/ModalContent/Verification.json
// module id = 761
// module chunks = 0